import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashboardComponent } from '@features/dashboard/components/dashboard/dashboard.component';
import { WelcomePopComponent } from './components/dashboard/welcome-pop/welcome-pop.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, SmartusComponentsModule, WelcomePopComponent],
})
export class DashboardModule {}